import HomePage from 'home';
import { getHomeServerSideProps } from 'src/utils/ssr/get-home-server-side-props';

// Resolve the hosted domain → enterprise and default the visitor into their
// nearest store (or the configured default location) server-side, so the
// homepage renders with a menu context and CMS targeting in the initial HTML.
// Fails open to the generic marketplace homepage. See ECOMM-11826.
export const getServerSideProps = getHomeServerSideProps;

export default HomePage;
